//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TheRadarIsiBadge",

  props: {
    styles: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    computedStyles() {
      return {
        ...this.styles
      };
    },
  },
}
